import type {StateCreator} from 'zustand'
import type {FilesRoutePayload} from '../../page-data/payloads/files'
import type {PullRequestState} from '../../types'

export interface PullRequestSlice {
  pullRequest: {
    state: PullRequestState
    basePath: string
    id: string
    number: number
  }
  pullRequestActions: {
    updatePullRequestState: (pullRequestState: PullRequestState) => void
  }
}
export interface PullRequestSliceOpts {
  pullRequest: FilesRoutePayload['pullRequest']
}

export const createPullRequestSlice =
  ({
    pullRequest,
  }: PullRequestSliceOpts): StateCreator<PullRequestSlice, [['zustand/devtools', never]], [], PullRequestSlice> =>
  (set, get) => {
    return {
      pullRequest: {
        state: pullRequest.state,
        basePath: pullRequest.pathName,
        id: pullRequest.id,
        number: pullRequest.number,
      },
      pullRequestActions: {
        updatePullRequestState: newPullRequestState => {
          set(
            {
              pullRequest: {
                ...get().pullRequest,
                state: newPullRequestState,
              },
            },
            undefined,
            'pullRequest#updatePullRequestState',
          )
        },
      },
    }
  }
